import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', labelKey: 'common.english' },
  { code: 'es', labelKey: 'common.spanish' },
  { code: 'fr', labelKey: 'common.french' },
];

export default function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();

  return (
    <label className={`lang-switcher ${className}`}>
      <span className="sr-only">{t('common.language')}</span>
      <select value={i18n.language} onChange={(e) => i18n.changeLanguage(e.target.value)}>
        {LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code}>{t(lang.labelKey)}</option>
        ))}
      </select>
    </label>
  );
}
